<template>
	<v-container align-center>
		<v-dialog
			v-if="isRetailAdmin"
			:value="this.showDialog"
			persistent
			max-width="400"
			max-height="400"
			content-class="confirm-dialog"
		>
			<v-layout align-center justify-center column>
				<v-flex>Would you like to delete this item?</v-flex>
				<v-flex>
					<v-btn
						dark
						depressed
						color="success"
						@click="cancelDeleteUserStory()"
						:disabled="confirmDeleteUserStoryLoading"
						>Cancel</v-btn
					>
					<v-btn
						dark
						depressed
						color="#ff0000"
						@click="confirmDeleteUserStory()"
						:disabled="confirmDeleteUserStoryLoading"
						>Confirm</v-btn
					>
				</v-flex>
			</v-layout>
		</v-dialog>
		<v-layout justify-center>
			<v-flex xs12 sm12 md8>
				<v-layout justify-center row wrap>
					<v-flex pa-1 xs12 sm6>
						<v-autocomplete
							label="Select State"
							v-model="selectedState"
							:items="states"
							:autcomplete="false"
							placeholder="Select State"
							class="text-field-wrapper pt-4"
							clearable
						></v-autocomplete>
					</v-flex>
					<v-flex pa-1 xs12 sm6>
						<v-autocomplete
							v-model="selectedCity"
							label="Select City"
							:items="cities"
							:autcomplete="false"
							:loading="fetchCitiesLoading"
							:disabled="isSelectedStateEmpty"
							placeholder="Select City"
							class="text-field-wrapper pt-4"
							clearable
						></v-autocomplete>
					</v-flex>
				</v-layout>
				<v-layout justify-center row wrap>
					<v-btn
						tile
						:color="themeInputColor"
						class="btn white--text ml-2 mr-2 mt-2 mb-4"
						:disabled="loadingMoreStories"
						@click="newSearch"
					>
						Search
					</v-btn>
					<v-btn
						outline
						:color="themeInputColor"
						class="btn ml-2 mr-2 mt-2 mb-4"
						:disabled="loadingMoreStories"
						@click="resetSearch"
					>
						Reset
					</v-btn>
				</v-layout>
				<stories-grid :deleteUserStory="deleteUserStory" />
				<v-layout justify-center row wrap>
					<v-btn
						tile
						:color="themeInputColor"
						class="btn white--text ml-2 mr-2 mt-2 mb-2"
						@click="loadMoreItems"
						:loading="loadingMoreStories"
						v-if="userStories.canLoadMoreStories"
					>
						Load More
					</v-btn>
				</v-layout>
				<v-layout justify-center>
					<v-btn
						icon
						right
						bottom
						fixed
						small
						fab
						:color="themeInputColor"
						@click="$vuetify.goTo(target, options)"
					>
						<v-icon color="#fff">keyboard_arrow_up</v-icon>
					</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import StoriesGrid from "./storiesGrid";

import {
	FETCH_REGIONS,
	FETCH_USER_STORIES,
	DELETE_USER_STORY
} from "@/store/action-types";

import { TOP, END } from "@/store/config";

import { REGION_TYPE, themeInputColor } from "@/utils";

export default {
	components: {
		"stories-grid": StoriesGrid
	},
	mounted() {
		this.selectedState = this.defaultState;
		this.selectedCity = this.defaultCity;
		this.fetchItems();
	},
	data() {
		return {
			target: 0,
			storiesOffset: 0,
			selectedCity: "",
			selectedState: "",
			fetchCitiesLoading: false,
			loadingMoreStories: false,
			showDialog: false,
			userStoryToDelete: null,
			confirmDeleteUserStoryLoading: false,
			themeInputColor
		};
	},
	computed: {
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin"
		}),
		...mapState({
			states: state => state.common.states,
			cities: state => state.common.cities,
			userStories: state => state.jeet11.userStories,
			defaultCity: state => (state.retail.retailerData || {}).city,
			defaultState: state => (state.retail.retailerData || {}).state
		}),
		isSelectedStateEmpty() {
			return !this.selectedState;
		},
		options() {
			return {
				duration: 300
			};
		}
	},
	methods: {
		fetchCities() {
			this.fetchCitiesLoading = true;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.CITY,
					state: this.selectedState,
					dataKey: "cities"
				})
				.catch(() => {})
				.then(() => {
					this.fetchCitiesLoading = false;
				});
		},
		fetchItems(type) {
			this.loadingMoreStories = true;
			let payload = {};
			payload.offset = this.storiesOffset;
			if (this.selectedState) payload.state = this.selectedState;
			if (this.selectedCity) payload.city = this.selectedCity;
			if (type) payload.type = type;
			this.$store
				.dispatch(FETCH_USER_STORIES.dispatch, payload)
				.then(() => {
					this.loadingMoreStories = false;
				});
		},
		newSearch() {
			this.storiesOffset = 0;
			this.fetchItems(TOP);
		},
		resetSearch() {
			this.selectedCity = null;
			this.selectedState = null;
			this.storiesOffset = 0;
			this.fetchItems(TOP);
		},
		loadMoreItems() {
			this.storiesOffset += this.userStories.limit;
			this.fetchItems(END);
		},
		deleteUserStory(storyData) {
			this.showDialog = true;
			this.userStoryToDelete = storyData;
		},
		cancelDeleteUserStory() {
			this.showDialog = false;
			this.userStoryToDelete = null;
		},
		confirmDeleteUserStory() {
			this.confirmDeleteUserStoryLoading = true;
			let payload = {};
			if (this.userStoryToDelete) {
				if (this.userStoryToDelete.storyId) {
					payload.storyId = this.userStoryToDelete.storyId;
					payload.status = "INACTIVE";
					this.$store
						.dispatch(DELETE_USER_STORY.dispatch, payload)
						.then(() => {
							this.confirmDeleteUserStoryLoading = false;
							this.showDialog = false;
							this.storiesOffset -= 1;
						});
				}
			}
		}
	},
	watch: {
		selectedState(newVal) {
			if (newVal) {
				this.fetchCities();
			} else {
				this.selectedCity = null;
			}
		}
	}
};
</script>

<style lang="scss">
.theme--light.v-pagination {
	margin: 4vh 0px;
	li {
		.v-pagination__navigation {
			margin: 0px 4px;
		}
		.v-pagination__item {
			min-width: 26px;
			padding: 3px;
			margin: 2px 3px;
		}
		.v-pagination__more {
			margin: 0;
		}
	}
}
.confirm-dialog {
	display: flex;
	padding: 20px;
	background-color: #fafafa;
}
</style>
